const GET_MOVIES_REQUEST = "GET_MOVIES_REQUEST";
const GET_MOVIES_SUCCESS = "GET_MOVIES_SUCCESS";
const GET_MOVIES_FAILURE = "GET_MOVIES_FAILURE";

const GET_OUTDOOR_EVENTS_REQUEST = "GET_OUTDOOR_EVENTS_REQUEST";
const GET_OUTDOOR_EVENTS_SUCCESS = "GET_OUTDOOR_EVENTS_SUCCESS";
const GET_OUTDOOR_EVENTS_FAILURE = "GET_OUTDOOR_EVENTS_FAILURE";

const GET_LAUGHTER_EVENTS_REQUEST = "GET_LAUGHTER_EVENTS_REQUEST";
const GET_LAUGHTER_EVENTS_SUCCESS = "GET_LAUGHTER_EVENTS_SUCCESS";
const GET_LAUGHTER_EVENTS_FAILURE = "GET_LAUGHTER_EVENTS_FAILURE";

const GET_POPULAR_EVENTS_REQUEST = "GET_POPULAR_EVENTS_REQUEST";
const GET_POPULAR_EVENTS_SUCCESS = "GET_POPULAR_EVENTS_SUCCESS";
const GET_POPULAR_EVENTS_FAILURE = "GET_POPULAR_EVENTS_FAILURE";

const GET_LATEST_EVENTS_REQUEST = "GET_LATEST_EVENTS_REQUEST";
const GET_LATEST_EVENTS_SUCCESS = "GET_LATEST_EVENTS_SUCCESS";
const GET_LATEST_EVENTS_FAILURE = "GET_LATEST_EVENTS_FAILURE";

export {
    GET_MOVIES_FAILURE,
    GET_MOVIES_SUCCESS,
    GET_MOVIES_REQUEST,
    GET_OUTDOOR_EVENTS_REQUEST,
    GET_OUTDOOR_EVENTS_SUCCESS,
    GET_OUTDOOR_EVENTS_FAILURE,
    GET_LAUGHTER_EVENTS_REQUEST,
    GET_LAUGHTER_EVENTS_SUCCESS,
    GET_LAUGHTER_EVENTS_FAILURE,
    GET_POPULAR_EVENTS_REQUEST,
    GET_POPULAR_EVENTS_SUCCESS,
    GET_POPULAR_EVENTS_FAILURE,
    GET_LATEST_EVENTS_REQUEST,
    GET_LATEST_EVENTS_SUCCESS,
    GET_LATEST_EVENTS_FAILURE
}